import Live from "images/live.svg"

export default function LiveTag() {
  return (
    <div className="absolute -left-2 -top-3 w-12 lg:-top-6 lg:left-0">
      <Live />
    </div>
  )
}
